




















import { Component, Vue } from "vue-property-decorator";

@Component({})
export default class Navigation extends Vue {
  scrollToContact() {
    Vue.prototype.common.appScrollTo("#contact-section");
    
    let contactBtn: HTMLElement = document.querySelector(".contact-section-main button") as HTMLElement;
    setTimeout(() => {
      contactBtn.click();
    }, 500);
  }
}
